import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import omiAvatar from "@/assets/omi-mascot.png";

const OmiFloatingButton = () => {
  const location = useLocation();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("omi-hidden") === "1");

  if (location.pathname === "/mind-buddy" || hidden) return null;

  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    sessionStorage.setItem("omi-hidden", "1");
    setHidden(true);
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 group">
      <button
        onClick={handleDismiss}
        className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-muted border border-border flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-50"
        aria-label="Hide Omi"
      >
        <X className="w-3 h-3 text-muted-foreground" />
      </button>
      <Link
        to="/mind-buddy"
        className="block w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 active:scale-95"
        aria-label="Chat with Omi"
      >
        <img
          src={omiAvatar}
          alt="Chat with Omi"
          className="w-full h-full rounded-full object-cover"
        />
      </Link>
    </div>
  );
};

export default OmiFloatingButton;
